import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as userActions from '../../global/user/actions/index';
import * as slidesActions from '../actions/index';
import DocumentDropZone from '../document_drop_zone/document_drop_zone';

class ConverterIndex extends Component {

    componentDidMount() {
        this.props.onUpdateAuthToken();
    }

    handleFile = (file, addBlankSlides) => {
        this.props.onImportDocument(file, addBlankSlides, (doc) => {
            this.props.history.push('/slides/editor/' + doc.id);
        });
    }

    handleAiFile = (file, customPrompt, addBlankSlides) => {
        this.props.onAiDraftDocument(file, customPrompt, addBlankSlides, (draft) => {
            // Store draft in sessionStorage so the editor page can pick it up
            // (converter and editor have separate Redux stores)
            sessionStorage.setItem('wk_ai_draft', JSON.stringify(draft));
            window.location.href = '/slides/editor';
        });
    }

    render() {
        return (
            <div className="w-full flex flex-col bg-gray-100 p-8">
                <div className="max-w-2xl w-full mx-auto">
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">Document Converter</h1>
                    <p className="text-gray-500 mb-6">Import .pages or .docx files into the slide editor</p>

                    <DocumentDropZone
                        onFile={this.handleFile}
                        onAiFile={this.handleAiFile}
                        loading={this.props.importing_document}
                        loadingText="Importing document..."
                        error={this.props.import_error}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        importing_document: state.slides.importing_document,
        import_error: state.slides.import_error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback)),
        onImportDocument: (file, addBlankSlides, callback) => dispatch(slidesActions.importDocument(file, addBlankSlides, callback)),
        onAiDraftDocument: (file, customPrompt, addBlankSlides, callback) => dispatch(slidesActions.aiDraftDocument(file, customPrompt, addBlankSlides, callback)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConverterIndex));
